import React, { useState } from "react"
import { ButtonEcomm, PartImage } from "@ncs/web-legos"
import { NonParentCustomerPart } from "@ncs/ncs-api"
import { QuantityControl } from "~/shared-components"
import { useShopContext } from "~/contexts"
import {
	cartActionsStyle,
	cartContainer,
	cartQtySelectStyle,
	inStockStyle,
	noteStyle,
	partImageStyle,
	priceStyle,
	productListItemDetailStyle,
	productListItemStyle,
	suggestedStyle,
} from "./style"
import { ExplodedPart } from "../types"
import { UnitMapping } from "~/shared-components/quantity-control/UnitMapping"

type PartListItemProps = {
	isActive: boolean
	onSetSelectedHotspot: (partNumber: string) => void
	onAddToCart: (partId: string) => void
	item: ExplodedPart
	idx: number
}

function mapExplodedPartToCustomerPart(item: ExplodedPart): NonParentCustomerPart {
	return {
		id: String(item.onlinePartId),
		description: item.partNumber,
		flatShippingRate: null,
		imageUrl: item.imageUrl ?? null,
		childImage: null,
		isActive: item.isActive === 1,
		isShippedFlatRate: false,
		netPrice: item.netPrice ?? item.price ?? 0,
		childNetPrice: null,
		onlinePartNumber: item.partNumber ?? null,
		part: {
			id: String(item.onlinePartId),
			description: item.description,
			partNumber: item.partNumber,
			unitOfMeasure: item.unitOfMeasure ?? "",
		},
		price: String(item.price),
		shippingLeadDays: 0,
		title: item.partNumber ?? null,
		isParent: false,
		isChild: false,
		variantCount: 0,
		brandName: null,
		featuredItem: false,
		clearanceItem: false,
		clearanceItemDiscount: null,
		variants: [],
	}
}

export const PartListItem: React.FC<PartListItemProps> = ({
	isActive,
	item,
	onSetSelectedHotspot,
	onAddToCart,
}) => {
	const [, shopDispatch] = useShopContext()
	const [quantity, setQuantity] = useState<number>(1)

	const handleAddToCart = (part: ExplodedPart, qty: number) => {
		const customerPart = mapExplodedPartToCustomerPart(part)
		shopDispatch({
			type: "add parts to cart",
			payload: [{ part: customerPart, quantity: qty }],
		})
		onAddToCart(String(part.onlinePartId))
	}

	return (
		<article
			css={productListItemStyle}
			onMouseEnter={() => onSetSelectedHotspot(item.partNumber)}
		>
			<span className={`chip ${isActive ? "chip-active" : ""}`}>{item.partIndex}</span>
			<PartImage css={partImageStyle} src={item.imageUrl} />
			<div css={productListItemDetailStyle}>
				<h5>{item.description}</h5>
				<p>
					<small>#{item.partNumber}</small>
				</p>
				<p css={inStockStyle}>In Stock</p>
				<p css={priceStyle}>${item.netPrice ?? item.price}</p>
				<p css={noteStyle}>List Price</p>
			</div>
			<div css={cartContainer}>
				<div>
					<h5>Qty ({UnitMapping(item.unitOfMeasure ?? "")})</h5>
					<div css={cartActionsStyle}>
						<QuantityControl
							value={quantity}
							unitOfMeasure={item.unitOfMeasure}
							onChange={(value) => setQuantity(value)}
							useUpdateButton
							showLabel={false}
							showUnit={false}
							selectCss={cartQtySelectStyle}
						/>
						<ButtonEcomm
							variant="outline-cta"
							icon="cart-circle-plus"
							onClick={() => handleAddToCart(item, quantity)}
						/>
					</div>
				</div>
				<div css={suggestedStyle}>
					<h5>
						Suggested Qty: <span>{item.suggestedQuantity}</span>
					</h5>
				</div>
			</div>
		</article>
	)
}
